import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: "tm-empty-timeline",
    templateUrl: "./empty-timeline.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslateModule
    ]
})
export class EmptyTimelineComponent {

    @Input()
    isTimelineEmpty: boolean = false;
}